import { collection, getDocs, limit, query } from 'firebase/firestore';
import { firestore } from './firebase/firebase';
import { INCIDENTS_LIMIT, normaliserIncident, trierIncidents } from '../utils/serverMonitoring';

/**
 * Service « Monitoring serveur » — LECTURE SEULE de la collection `serverMonitoring` (lot I5).
 *
 * La collection est écrite par le SERVEUR (`deployment-service/src/services/server-monitoring.js`
 * et son jumeau portail) et seulement LUE ici : ce service ne fait aucune écriture (DI5-9, DI5-12).
 *
 * AUCUN INDEX : la lecture ne pose pas d'`orderBy` (le tri est fait EN MÉMOIRE par le module pur
 * `utils/serverMonitoring.trierIncidents`). C'est la doctrine déjà appliquée au lot I2a et au
 * script serveur `scripts/show-monitoring-incidents.js` : aucun `where` combiné à un `orderBy`
 * (qui, lui, exigerait un index composite à déployer).
 *
 * Droits : la lecture des incidents par un administrateur est DÉJÀ permise par les règles
 * (`msd_portail/firestore.rules`) ⇒ aucun déploiement n'est nécessaire pour ce sous-onglet (C2).
 */

/** Collection racine du canal d'escalade support (vocabulaire du serveur, constat C8). */
const MONITORING_COLLECTION = 'serverMonitoring';

/**
 * Incidents serveur — LECTURE SEULE.
 * @param {number} [max] - Nombre maximum d'incidents lus
 * @returns {Promise<Array<Object>>} Incidents normalisés, du plus récent au plus ancien
 */
export const getIncidents = async (max = INCIDENTS_LIMIT) => {
  try {
    const snapshot = await getDocs(query(
      collection(firestore, MONITORING_COLLECTION),
      limit(max)
    ));
    return trierIncidents(snapshot.docs.map((docSnap) => normaliserIncident(docSnap.id, docSnap.data())));
  } catch (error) {
    // L'erreur REMONTE : un écran de preuve ne doit pas afficher « aucun incident » quand la
    // lecture a échoué (permission, réseau) — le sous-onglet distingue les deux situations.
    console.warn('serverMonitoringService: incidents introuvables', error?.message);
    throw error;
  }
};

export { INCIDENTS_LIMIT, MONITORING_COLLECTION };
